"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _CopyButton = _interopRequireDefault(require("./button/CopyButton"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ObjectId = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ObjectId, _Component);

  var _super = _createSuper(ObjectId);

  function ObjectId() {
    var _this;

    (0, _classCallCheck2["default"])(this, ObjectId);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(ObjectId, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          showFull = _this$props.showFull,
          className = _this$props.className,
          style = _this$props.style,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["id", "showFull", "className", "style"]);
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);
      return /*#__PURE__*/_react["default"].createElement(_CopyButton["default"], (0, _extends2["default"])({
        className: rootCSS,
        text: id
      }, otherProps), /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.identifier)
      }, showFull ? id : "...".concat(id.substring(id.length - 5))));
    }
  }, {
    key: "styles",
    get: function get() {
      var fonts = this.context.theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          padding: "10px 0px",
          fontFamily: fonts.regular
        },
        identifier: {
          fontSize: 14,
          userSelect: "none",
          marginRight: 5,
          flexShrink: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      });
    }
  }]);
  return ObjectId;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  id: {
    required: true,
    type: "string",
    description: "ObjectId to be rendered"
  },
  showFull: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Indicates that the full id should be not " + "- will not be truncated"
  },
  copyOnBodyClick: {
    required: true,
    type: "boolean",
    defaultValue: "true",
    description: "Indicates that id should be copied to clipboard, " + "when the component is clicked"
  }
}, _class3.defaultProps = {
  copyOnBodyClick: true
}, _class3.demoProps = {
  id: "579ef6c6629c385fbe182db8",
  copyOnBodyClick: true
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = ObjectId;
exports["default"] = _default;